
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"17","viewBox":"4.5 3.5 15 17","fill":"none","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.498 19.498H6.665a.835.835 0 01-.834-.834v-.677a3.5 3.5 0 013.49-3.489h5.52a3.5 3.5 0 013.491 3.49v.676c0 .46-.373.833-.834.834zM12.082 11.248a3.375 3.375 0 110-6.75 3.375 3.375 0 010 6.75v0z"}})])
          )
        }
      }
    